module.exports = __webpack_public_path__ + "media/images/icon__unlocked@2x-c1a0b022bdfb2b705505cf8c2b95fc9c.png";